let state = {
    
    tipo_documento:[],
    profissao:[],
    escolaridade:[],
    sexo:[],
    estado_civil:[],
    pais:[],
    estado_naturalidade:[],
    cidade_naturalidade:[],
    estado_endereco:[],
    cidade_endereco:[],

}

export default state